import gql from 'graphql-tag'

const USER_QUERY = `
  id
  name
  is_active
  status_text
  email
  role_id
  role {
    id
    name
  }
`

/**
 * Query
*/
const ALL = gql`
  query users($email: String, $status: Boolean) {
    users(email: $email, status: $status) {
      ${USER_QUERY}
    }
  }
`
const GET_WITH_PAGINATION = gql`
  query usersWithPagination ($page: Int, $perPage: Int, $search: String) {
    usersWithPagination (page: $page, first: $perPage, search: $search) {
      paginatorInfo {
        currentPage
        count
        hasMorePages
        perPage
        total
      }
      data {
        ${USER_QUERY}
      }
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createUser ($input: UserCreateInput!) {
    createUser (input: $input) {
      ${USER_QUERY}
    }
  }
`

const UPDATE = gql`
  mutation updateUser ($id: ID!, $input: UserUpdateInput!) {
    updateUser (id: $id, input: $input) {
      ${USER_QUERY}
    }
  }
`

const DELETE = gql`
  mutation deleteUser ($id: ID!) {
    deleteUser (id: $id) {
        id
    }
  }
`

export {
    ALL,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE
}
